import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CartItem, CartItemGroup, CartItemType } from '../cart.model';
import { CreativeUnitWithCustomizationsDto } from '../../../../../../../api/src/creative-unit-package/models/creative-unit/creative-unit.dto';
import { CartService } from "../cart.service";
import { DeleteCartItemMode } from "../../../../pages/project/project.page";

@Component({
  selector: 'app-cart-list',
  templateUrl: './cart-list.component.html',
  styleUrls: ['./cart-list.component.scss']
})
export class CartListComponent implements OnChanges {
	protected readonly DeleteCartItemMode = DeleteCartItemMode;
	public readonly CartItemType = CartItemType;

	@Input() preprocessedGroups: CartItemGroup[]; // groups that have already been converted from item[]->group[]
	@Input() items: CartItem[];

	@Input() mode: 'list' | 'checkout' | 'post-checkout'; // Determines the template being used.
	@Input() showHeader: boolean = true;
	@Input() showSizeCount: boolean = true;
	@Input() showExpandableDetails  = false;
	@Input() showGroupActions  = true;
	@Input() showReview  = false;
	@Input() showPaginator  = true;
	@Input() useItemTranslations: boolean = false; // Use when we are not handling a real item, but a preview.
	@Input() forcePanelsOpen: boolean = false; // force panels open on init

	@Input() highlightQuery: string; // Highlight a regex match in the group/item names
	@Input() paginatorPageSize = 6;
	@Input() actionInProgress: {group?: any, itemIds?: string[]} | null;

	@Output() goToItem: EventEmitter<{ item: CartItem, group: CartItemGroup }> = new EventEmitter<{ item: CartItem, group: CartItemGroup }>();
	@Output() goToGroup: EventEmitter<CartItemGroup> = new EventEmitter<CartItemGroup>();

	@Output() deleteItems: EventEmitter<{ items: CartItem[], mode: DeleteCartItemMode }> = new EventEmitter<{ items: CartItem[], mode: DeleteCartItemMode }>();
	@Output() exportItem = new EventEmitter<CartItem>();
	@Output() groupAction = new EventEmitter<{action: string, group: CartItemGroup | any}>();
	@Output() itemAction = new EventEmitter<{action: string, item: CartItem | any}>();

	public expandedItems: { [key: string]: boolean } = {};
	public groups: CartItemGroup[] = [];
	public paginatorCurrentPage: number = 1;

	constructor(
		private readonly projectCartService: CartService
	) { }

	ngOnChanges(changes: SimpleChanges): void {
		if (!changes.preprocessedGroups && !changes.items) return;

		let groups;
		if (changes.preprocessedGroups) {
			groups = this.preprocessedGroups;
		} else if (changes.items) {
			groups = this.projectCartService.convertItemsToGroups(changes.items?.currentValue || [], 'both');
		}
		// Group items
		this.groups = groups;

		this.updatePagination(this.paginatorCurrentPage - 1)
	}

	transformItemsToCreativeUnit(items: CartItem[]): CreativeUnitWithCustomizationsDto[] {
		return items.map(item => item.itemData);
	}

	getMinHeight(items: CartItem[], maxHeight = 0): number {
		return Math.max(maxHeight, ...items.map(item => item.metadata?.dimensions?.height));
	}

	updatePagination(pageIndex: number) {
		// handle packages being deleted
		if (Math.ceil(this.groups.length / this.paginatorPageSize) < pageIndex + 1) {
			pageIndex--;
		}

		this.paginatorCurrentPage = pageIndex + 1 > 0 ? pageIndex + 1 : 1;
	}

}
